import PropTypes from 'prop-types';
import React from 'react';
import Image from './Image';
import Dropdown from './ui/Dropdown';
import Radio from './ui/Radio';
import Range from './ui/Range';
import Toggle from './ui/Toggle';

class Question extends React.Component {
	getAnswer = (question, type) => {
		const answers = question.answers;
		const userInput = this.props.userInput;

		let answer;
		switch (type) {
			case 'scale':
				answer = (
					<Range
						key={question.ID}
						options={answers}
						scaleOptions={question.scale_options}
						defaultValue={userInput}
						handleChange={this.props.handleSliderChange}
					/>
				);
				break;
			case 'dropdown':
				answer = (
					<Dropdown
						key={question.ID}
						name={question.ID}
						options={answers}
						defaultValue={userInput}
						placeholder={question.dropdown_options.placeholder}
						handleChange={this.props.handleChange}
					/>
				);
				break;
			default:
				answer = Object.keys(answers).map((key) => {
					const uniqueKey = question.ID + '_' + key;
					const props = {
						id: key,
						name: question.ID,
						title: answers[key].label,
						checked: type === 'single' ? userInput === parseInt(key) : userInput && userInput.length ? userInput.includes(parseInt(key)) : false,
						handleChange: this.props.handleChange,
					};

					return type === 'single' ? <Radio key={uniqueKey} {...props} /> : <Toggle key={uniqueKey} {...props} />;
				});
		}

		return answer;
	};

	render() {
		const { question, labels } = this.props;
		const type = question.input_type;
		const answer_count = question.answers.length > 1 ? question.answers.length : 0;

		let hint = '';
		switch (type) {
			case 'multiple':
				hint = labels.multiple_hint;
				break;
			case 'single':
				hint = labels.appropriate_answer;
				break;
			case 'scale':
				hint = question.scale_options.type === 'fixed' ? labels.appropriate_answer : labels.estimate_in_percent;
				break;
		}

		return (
			<div className="ms-form__question" data-type={type} data-count={answer_count}>
				<div className="ms-form__headlines">
					{/* Main-Headline */}
					<h4>{question.title}</h4>
					{/* Sub-Headline eg. multiple choice */}
					<h5>{hint !== '' && `(${hint})`}</h5>
				</div>
				{question.image && <div className="ms-form__header-image">{question.image && <Image image={question.image} />}</div>}
				<div className="ms-form__answers">
					<div className={`ms-form__answers__${type}`}>{this.getAnswer(question, type)}</div>
				</div>
			</div>
		);
	}
}

export default Question;

Question.propTypes = {
	handleChange: PropTypes.func,
	handleSliderChange: PropTypes.func,
	labels: PropTypes.object,
	question: PropTypes.object,
	userInput: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.array]),
};
